import React from 'react'
import { TextField, InputAdornment } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'

const Lastname = ({ handleOnChange, error, register, value, withIcon  }) => {
  return (
    <TextField
    {...register('lastname', { required: 'This field is required' })}
      error={!!error}
      helperText={error?.message}
      variant="outlined"
      fullWidth
      id="lastname"
      label="Last name *"
      name="lastname"
      value={value}
      InputProps={{
        endAdornment: withIcon ? (
          <InputAdornment position="start">
            <PersonIcon />
          </InputAdornment>
        ) : null,
      }}
      onChange={handleOnChange}
    />
  )
}

export default Lastname
